import React from "react";

export function StatusBadge({ status }) {
  const map = {
    New: { bg: "#FEF3C7", fg: "#92400E" },
    Confirmed: { bg: "#DBEAFE", fg: "#1E40AF" },
    "In Production": { bg: "#FFEDD5", fg: "#9A3412" },
    Ready: { bg: "#D1FAE5", fg: "#065F46" },
    "Out for Delivery": { bg: "#EDE9FE", fg: "#5B21B6" },
    Delivered: { bg: "#141E30", fg: "#FFFFFF" },
    Cancelled: { bg: "#FEE2E2", fg: "#991B1B" },
    Lost: { bg: "#E4E4E7", fg: "#3F3F46" },
  };
  const c = map[status] || { bg: "#F3F4F6", fg: "#374151" };
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
      className="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full border border-transparent"
      style={{ backgroundColor: c.bg, color: c.fg }}
    >
      {status}
    </span>
  );
}
